import { render } from "./Judges.vue?vue&type=template&id=551b1be2"
import script from "./Judges.vue?vue&type=script&lang=js"
export * from "./Judges.vue?vue&type=script&lang=js"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__